import { TrendItem, TrendStatus, TrendUserIdentity } from "@/config/types/trend";
import "./Auther.less";
import DefaultUser from "@/images/trend/default-user.png";
import { CheckCircleOutline, ExclamationCircleOutline } from "antd-mobile-icons";
import { useMemo } from "react";
import { isNil } from "lodash";
import AuthedIcon from "@/containers/trend-audit/components/AuthedIcon";
import { isSdicHomeApp } from "@/utils/utils";
import realAuthedIcon from "@/images/trend-audit/icon-authed.png";
import realUnAuthIcon from "@/images/trend-audit/icon-unauth.png";
import IconOfficial from "@/images/icon/icon-official.png";
import { BigVipFlag } from "@/config/types/message";
import sdicHomeEmit from "@/utils/prototal";

interface AutherProps {
  theme: "light" | "dark";
  isAuditPage?: boolean;
  data: TrendItem;
}

export default function Auther({ theme, isAuditPage, data }: AutherProps) {
  const statusObj = {
    [TrendStatus.PENDING]: {
      // status: "pending",
      // text: "审核中",
    },
    [TrendStatus.SUCCESSS]: {
      status: "success",
      text: "审核通过",
      icon: <CheckCircleOutline />,
    },
    [TrendStatus.FAIL]: {
      status: "fail",
      text: "审核未通过",
      icon: <ExclamationCircleOutline />,
    },
  };

  const { status, text, icon } = useMemo(() => {
    if (isNil(data.auditStatus) || !statusObj[data.auditStatus]) {
      return {} as any;
    }
    const obj: any = statusObj[data.auditStatus];

    if (data.auditStatus === TrendStatus.SUCCESSS && !isAuditPage) {
      return {};
    }
    return obj;
  }, [data.auditStatus, isAuditPage]);

  // 跳转到该用户的主页
  const toTrendProfile = () => {
    if (isSdicHomeApp() && data?.imId) {
      window.console.log(data?.imId, "imId");
      const params = { imid: data?.imId };
      sdicHomeEmit("openMainPage", params);
    } else {
      window.console.log(data?.imId, "imId", "没进去");
    }
  };

  /**
   * userIdentity 是当时登录用户的身份，但企业用户又可以选择「个人身份/机构号」中的一种身份
   * 来进行发布。那发布后展示的头像，就不能用 userIdentity 来判断了。只有在 orgId 有值时，
   * 才表示是机构号发布的，没有值时，则认为成个人身份。
   */
  return (
    <div className={`auther-wrap auther-wrap-${theme}`}>
      <img
        src={data.imFaceUrl || DefaultUser}
        alt="头像"
        className="auther-avatar"
        onClick={toTrendProfile}
      />
      {data.orgId ? (
        <div className="auther-info" onClick={toTrendProfile}>
          <div className="auther-name">
            <strong className="nickname">{data.orgNickname}</strong>
            {data.orgAuth === "Y" && <AuthedIcon userIdentity={TrendUserIdentity.COMPANY} />}
            {data?.bigVipFlag === BigVipFlag.YES && (
              <img src={IconOfficial} alt="官方认证" className="icon-official" />
            )}
          </div>
          <div className="auther-identity">{data.orgName}</div>
        </div>
      ) : (
        <div className="auther-info" onClick={toTrendProfile}>
          <div className="auther-name personal">
            <strong className="nickname">{data.imNickName}</strong>
            <span className="name-icon">
              {data.verificationStatus &&
                (data.verificationStatus === 2 ? (
                  <img className="real-auth-status" src={realAuthedIcon} />
                ) : (
                  <img className="real-auth-status" src={realUnAuthIcon} />
                ))}
              {data.professionalGuide === "Y" && (
                <AuthedIcon
                  userIdentity={TrendUserIdentity.PERSONAL}
                  type="small"
                  level={data.boleLevel}
                />
              )}
            </span>
            {data?.bigVipFlag === BigVipFlag.YES && (
              <img src={IconOfficial} alt="官方认证" className="icon-official" />
            )}
          </div>
        </div>
      )}
      {status && (
        <div className={`trend-audit-status flex items-center ${status}`}>
          {icon}
          {text}
        </div>
      )}
    </div>
  );
}
